import { call, put, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { doHideLoading, doShowLoading, doShowResponse, doLoadedPage } from '../actions/ui';
import {
  doRequestSMS,
  doSaveClientInfo,
  doSaveClientType,
  doSaveSession,
} from '../actions/session';
import { createSession, requestToken, verifyToken } from '../api/session';
import { getClientType, getSessionId } from '../selectors/session';
import { handleFetchPlans } from './plan';
import { postMessageSender } from '../lib/postMessager';
import messages from '../enum/messages';
import { isDealersChannel } from '../lib/utils';
import { doSelectPlan } from '../actions/plan';
import contratoStatus from '../enum/contratoStatus';
import { getVendorInfo } from '../selectors/vendor';

function* handleCreateSession(action) {
  let { payload } = action;
  const { msisdn, cpf, plan } = payload;
  let { channel } = payload;
  yield put(doShowLoading());
  try {
    // TODO Essa etapa é uma POC e deve ser refatorada no futuro
    const vendorPayload = yield select(getVendorInfo);
    if (vendorPayload) {
      const { codigoPromotor, adabas } = vendorPayload;
      channel = vendorPayload.channel;
      payload = {
        msisdn,
        cpf,
        codigoPromotor,
        channel,
        adabas,
      };
    }
    // TODO refator ate aqui
    const { data } = yield call(createSession, payload);

    yield put(doSaveSession(data.id, msisdn, cpf, channel));
    yield put(doSaveClientType(data.contratoStatus));
    if (data.contratoStatus === contratoStatus.contratoAtivo) {
      const clientPlan = {
        codigo: data.clientInfo.dado.nome_interno_promocao,
      };
      yield put(doSaveClientInfo(data.clientInfo));
      yield put(doRequestSMS(clientPlan.codigo));
      yield put(doSelectPlan(clientPlan));
      yield put(push('/confirmacao-sms'));
    }

    if (isDealersChannel(channel)) {
      yield put(doSelectPlan(data.plan));
      yield put(doLoadedPage());
      yield put(push('/pagamentoV2'));
      postMessageSender({ action: 'session_created', sessionId: data.id });
    } else {
      yield call(handleFetchPlans, { sessionId: data.id, selectedPlan: plan });
    }
  } catch (e) {
    const { data } = e.response;
    yield put(doShowResponse('error', data));
    postMessageSender({
      action: 'execute_failed',
      code: 'FE_002',
      reason: data,
    });
  } finally {
    yield put(doHideLoading());
  }
}

function* handleRequestToken(action) {
  const { plan } = action;
  const sessionId = yield select(getSessionId);

  yield put(doShowLoading());
  try {
    yield call(requestToken, plan, sessionId);
    yield put(doShowResponse('success', messages.FE_004));
  } catch (e) {
    yield put(doShowResponse('error', messages.FE_005));
  }
  yield put(doHideLoading());
}

function* handleVerifyToken(action) {
  const { plan, token } = action.payload;
  const sessionId = yield select(getSessionId);
  const clientType = yield select(getClientType);

  yield put(doShowLoading());
  try {
    const { status } = yield call(verifyToken, plan, token, sessionId);

    if (status === 200 && clientType === 'contratoAtivo') {
      yield put(push('/trocar-cartao'));
    } else if (status === 200) {
      yield put(push('/pagamento'));
    }
  } catch (e) {
    if (e.response.status === 422) {
    }
  }
  yield put(doHideLoading());
}

export { handleCreateSession, handleRequestToken, handleVerifyToken };
